import { inject, singleton } from "tsyringe";

// shared
import { AccessStorageImpl } from "@/shared/libs/storage/AccessStorageImpl";

@singleton()
export class PersistStorageDeleter {
    constructor(@inject(AccessStorageImpl) private accessStorage: AccessStorageImpl) {}

    public delete = () => {
        const persistStorage = [
            "locationsStore",
            "middleUnitsStore",
            "plannedCurriculumsStore",
            "academyClassesStore",
        ];

        persistStorage.forEach((key) => this.accessStorage.removeItem(key));
    };
}
